import { render, staticRenderFns } from "./DoctorProduction.vue?vue&type=template&id=e71b5a0a&scoped=true&"
import script from "./DoctorProduction.vue?vue&type=script&lang=js&"
export * from "./DoctorProduction.vue?vue&type=script&lang=js&"
import style0 from "./DoctorProduction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DoctorProduction.vue?vue&type=style&index=1&id=e71b5a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71b5a0a",
  null
  
)

export default component.exports